export default "__VITE_ASSET__DJc06gs3__"